import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "@/components/Header";
import { api } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function Verify() {
  const { certId } = useParams();
  const [cert, setCert] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.verify(certId).then(setCert).catch(() => setErr("Certificate not found or has been revoked."));
  }, [certId]);

  return (
    <div className="min-h-screen text-white" style={{ background: "var(--kl-navy-deep)" }}>
      <Header />
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-12 relative">
        <div className="absolute top-20 left-1/2 -translate-x-1/2 w-[500px] h-[500px] rounded-full opacity-15 blur-3xl pointer-events-none" style={{ background: "radial-gradient(circle, rgba(230,57,70,0.55), transparent 60%)" }} />
        <Link to="/" className="relative z-10 font-mono-kl text-xs uppercase tracking-widest text-white/60 hover:text-white inline-flex items-center gap-2 mb-6">
          <ArrowLeft className="w-4 h-4" /> Home
        </Link>
        <div className="relative z-10 font-mono-kl text-xs uppercase tracking-[0.3em] text-[color:var(--kl-red)]">
          <span className="kl-accent-line mr-3" />PROCTORLY VERIFICATION
        </div>
        <h1 className="font-display text-5xl md:text-7xl uppercase tracking-tight leading-[0.9] mt-2 text-white">
          {cert ? "Certificate" : err ? "Not Found" : "Loading…"}
        </h1>

        {err && (
          <div className="mt-6 rounded-md border border-white/10 p-6 relative z-10" data-testid="verify-err" style={{ background: "rgba(255,255,255,0.02)" }}>
            <p className="text-lg text-white/80">{err}</p>
            <Link to="/" className="btn-submit inline-flex mt-4">Back to home</Link>
          </div>
        )}

        {cert && (
          <div className="mt-6 bg-white border border-black/10 p-8 rounded-md text-[color:var(--kl-ink)] relative z-10" data-testid="verify-card">
            <div className="flex flex-wrap items-center justify-between gap-3 border-b-2 border-black/10 pb-4">
              <div className="font-display text-2xl">KIBA<span className="text-[color:var(--kl-red)]">/</span>LABS</div>
              <div className="font-mono-kl text-[10px] uppercase tracking-widest text-black/60">Cert ID · {cert.certificate_id}</div>
            </div>
            <div className="mt-6">
              <div className="font-mono-kl text-[11px] uppercase tracking-widest text-black/50">This certifies</div>
              <div className="font-display text-4xl md:text-6xl uppercase mt-1">{cert.name}</div>
              <div className="font-mono-kl text-[11px] uppercase tracking-widest text-black/50 mt-4">Topic</div>
              <div className="font-display text-2xl uppercase">{cert.topic_label}</div>
              <div className="font-mono-kl text-[11px] uppercase tracking-widest text-black/50 mt-4">Score</div>
              <div className="font-display text-7xl text-[color:var(--kl-red)] leading-none">{cert.percent}%</div>
              <span className="inline-block bg-[color:var(--kl-red)] text-white px-3 py-1 mt-3 font-display uppercase rounded-full text-sm">
                {cert.level}
              </span>
            </div>
            <div className="mt-6 border-t-2 border-black/10 pt-4 font-mono-kl text-[11px] uppercase tracking-widest text-black/60">
              ✓ VERIFIED · Issued {new Date(cert.issued_at).toLocaleDateString()} · Proctorly AI Engine · Claude Sonnet 4.6
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
